export const inlineGalleryFunction = (lightGallery, lgThumbnail, lgZoom) => {
    const $lgContainer = document.getElementById("inline-gallery-container");

    if ($lgContainer) {
        var images = atob($lgContainer.dataset.images);
        // console.log(images);

        const inlineGallery = lightGallery($lgContainer, {
            container: $lgContainer,
            dynamic: true,
            // Turn off hash plugin in case if you are using it
            // as we don't want to change the url on slide change
            hash: false,
            // Enable download button.
            download: false,
            // Do not allow users to close the gallery
            closable: false,
            closeOnTap: true,
            // Add maximize icon to enlarge the gallery
            showMaximizeIcon: true,
            // Append caption inside the slide item
            // to apply some animation for the captions (Optional)
            appendSubHtmlTo: ".lg-item",
            // Delay slide transition to complete captions animations
            // before navigating to different slides (Optional)
            // You can find caption animation demo on the captions demo page
            slideDelay: 400,
            plugins: [lgZoom, lgThumbnail],
            dynamicEl: JSON.parse(images),

            // Completely optional
            // Adding as the codepen preview is usually smaller
            thumbWidth: 120,
            thumbHeight: "80px",
            thumbMargin: 5
        });
        inlineGallery.openGallery();
    }
}